(() => {
  const FIELD_NAMES = {
    contactType: 'contact[Contacting as]',
    company: 'contact[Company Name]',
    country: 'contact[Country]',
    vat: 'contact[VAT Number]',
    website: 'contact[Website]',
    reason: 'contact[Reason For Contacting Us]',
    order: 'contact[Order Number]',
    product: 'contact[Product / SKU of Interest]',
    wholesale: 'contact[Wholesale Requirement]'
  };

  const PRODUCT_REASONS = new Set([
    'Wholesale / Production Supply',
    'Regulatory & Compliance',
    'Product Selection',
    'Samples'
  ]);

  function initContactForm(form) {
    if (!form || form.dataset.conditionalContactInitialized === 'true') return;

    const getField = (name) => form.querySelector(`[name="${name}"]`);
    const fields = {
      contactType: getField(FIELD_NAMES.contactType),
      company: getField(FIELD_NAMES.company),
      country: getField(FIELD_NAMES.country),
      vat: getField(FIELD_NAMES.vat),
      website: getField(FIELD_NAMES.website),
      reason: getField(FIELD_NAMES.reason),
      order: getField(FIELD_NAMES.order),
      product: getField(FIELD_NAMES.product),
      wholesale: getField(FIELD_NAMES.wholesale)
    };

    if (!fields.contactType || !fields.reason) return;

    const message = form.querySelector('.form-field--body textarea');
    const messageLabel = form.querySelector('[data-contact-message-label]');
    const defaultMessageLabel = messageLabel?.textContent?.trim() || 'Message';
    const defaultMessagePlaceholder = message?.dataset.defaultPlaceholder || message?.getAttribute('placeholder') || 'Message';

    const setFieldState = (input, visible, required = false) => {
      if (!input) return;
      const wrapper = input.closest('.form-field');
      if (!wrapper) return;

      wrapper.hidden = !visible;
      input.disabled = !visible;
      input.required = visible && required;
      input.toggleAttribute('aria-required', visible && required);

      if (!visible) {
        if (input.matches('select')) input.selectedIndex = 0;
        else if (input.matches('input[type="checkbox"], input[type="radio"]')) input.checked = false;
        else input.value = '';
      }
    };

    const update = () => {
      const reason = fields.reason.value;
      const business = fields.contactType.value === 'Business';
      const wholesale = reason === 'Wholesale / Production Supply';
      const businessContext = business || wholesale;

      setFieldState(fields.company, businessContext, businessContext);
      setFieldState(fields.vat, businessContext, false);
      setFieldState(fields.website, businessContext, false);
      setFieldState(fields.order, reason === 'Order Status', false);
      setFieldState(fields.product, PRODUCT_REASONS.has(reason), false);
      setFieldState(fields.wholesale, wholesale, wholesale);

      if (message && messageLabel) {
        if (wholesale) {
          messageLabel.textContent = 'Tell us about your requirements';
          message.placeholder = 'Product(s), intended application, expected volume, timeline, and any regulatory requirements.';
        } else {
          messageLabel.textContent = defaultMessageLabel;
          message.placeholder = defaultMessagePlaceholder;
        }
      }
    };

    const prefillFromQuery = () => {
      const params = new URLSearchParams(window.location.search);
      const reasonParam = (params.get('reason') || '').toLowerCase();
      const quantityParam = (params.get('quantity') || '').toLowerCase();
      const volumeParam = (params.get('volume') || '').toLowerCase();
      const productParam = params.get('product') || '';

      if (reasonParam === 'wholesale') {
        fields.reason.value = 'Wholesale / Production Supply';
        if (fields.contactType && !fields.contactType.value) fields.contactType.value = 'Business';
      }

      update();

      if ((volumeParam === 'larger' || quantityParam === '40plus') && fields.wholesale) {
        fields.wholesale.value = 'Larger formats up to 1 L';
      }
      if (productParam && fields.product) {
        fields.product.value = productParam.replace(/-/g, ' ');
      }
    };

    fields.contactType.addEventListener('change', update);
    fields.reason.addEventListener('change', update);
    prefillFromQuery();
    form.dataset.conditionalContactInitialized = 'true';
  }

  function initAll(root = document) {
    root.querySelectorAll('form[id^="ContactForm-"]').forEach(initContactForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
